import { render, staticRenderFns } from "./AddOrEditAppointmentTypeForm.vue?vue&type=template&id=55bdc7b9"
import script from "./AddOrEditAppointmentTypeForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditAppointmentTypeForm.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditAppointmentTypeForm.vue?vue&type=style&index=0&id=55bdc7b9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports